<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Từ ngày</label>
              <date-picker v-model="filterData.from_date" valueType="format"></date-picker>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Đến ngày</label>
              <date-picker v-model="filterData.to_date" valueType="format"></date-picker>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Số điện thoại</label>
              <input type="text" class="form-control" v-model="filterData.number" placeholder="Nhập số điện thoại..."/>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Người dùng</label>
              <multiselect v-model="selectedUser" id="ajax" label="name" track-by="code"
                           placeholder="Nhập để tìm kiếm người dùng"
                           open-direction="bottom" :options="users" :multiple="false" :searchable="true"
                           :loading="loadingUser" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           @remove="onRemoveUser"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceUser">
              </multiselect>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Trạng thái cuộc gọi</label>
              <multiselect v-model="filterData.call_status" :options="call_status_list" :multiple="false"
                           :close-on-select="true"
                           placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-end align-items-center ">
              <b-button variant="warning" @click="search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
              </b-button>
            </div>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Danh sách ghi âm">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(id)="data">
                {{genSeqId(data)}}
              </template>
              <template v-slot:cell(direction)="data">
                {{data.item.direction === 'incoming' ? 'Cuộc gọi đến' : 'Cuộc gọi đi'}}
              </template>

              <template v-slot:cell(calldate)="data">
                {{ data.item.calldate | format_date_time}}
              </template>

              <template v-slot:cell(actions)="dataId">
                <b-button variant="warning" v-b-tooltip.hover title="Play" @click="play(dataId.item)">
                  <i class="fa fa-play" aria-hidden="true"></i>
                </b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>

      <b-modal size='xl' id="playRecordModal" hide-footer title="Ghi âm cuộc gọi">
        <CallRecord :callRecord="currentRecord"></CallRecord>
      </b-modal>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import callCenterAPI from '../../api/callCenter'
import Utils from '../../common/utils'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CallRecord from '../../components/CallRecord'
import {debounce} from 'lodash'
import UserApi from '../../api/user'
import {mapGetters} from 'vuex'
import Multiselect from '../../lib/vue-multiple-select/Multiselect'
import * as Constants from '../../common/constant'

export default {
  name: 'CallRecords',
  components: {
    CallRecord,
    'va-box': VABox,
    DatePicker,
    Multiselect
  },
  data () {
    return {
      filterData: {
        from_date: moment().subtract(1, 'days').format('yyyy-MM-DD'),
        to_date: moment().format('yyyy-MM-DD'),
        user_id: null,
        number: null,
        call_status: null
      },
      call_status_list: Constants.CALL_STATUS_LIST,
      currentRecord: null,
      items: [],
      fields: [
        {
          key: 'id',
          label: 'STT'
        },
        {
          key: 'dest_number',
          label: 'Số điện thoại'
        },
        {
          key: 'calldate',
          label: 'Ngày thực hiện'
        },
        {
          key: 'direction',
          label: 'Cuộc gọi'
        },
        {
          key: 'duration',
          label: 'Thời lượng đàm thoại(giây)'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 20px',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      selectedUser: null,
      users: [],
      loadingUser: false,
      debounceUser: null,
    }
  },
  created () {
    this.debounceUser = debounce(this.filterUser.bind(this), 500)
  },
  mounted () {
    this.filter()
    this.filterUser('')
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      let filter = {...this.filterData}
      if (this.selectedUser) {
        filter.user_id = this.selectedUser.code
      }
      filter.call_status = this.filterData.call_status ? this.filterData.call_status.value : null
      callCenterAPI.get_company_call_history(filter, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    play (item) {
      this.currentRecord = item
      this.$bvModal.show('playRecordModal')
    },
    filterUser (query) {
      this.loadingUser = true
      const company = Utils.getCompanyByUserInfo(this.userInfo)
      UserApi.findByName(query, company.id, 0, 200).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })
        this.loadingUser = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    onRemoveUser (event) {
      this.selectedUser = null
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/call_center/CallRecords.vue